var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSmarter = function SvgSmarter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4FE",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M75.086 37.54A36.544 36.544 0 1 1 2 37.543a36.544 36.544 0 0 1 73.087-.005Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4FF",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M71.407 53.523a30 30 0 0 1-8.691 11.424 36.55 36.55 0 0 1-53.831-6.062v-4.531c0-4.809 4.83-8.743 10.724-8.743h41.074c5.901.008 11.934 5.071 10.724 7.912Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M30.45 40.81h17.893c3.475 0 5.98-4.8 5.004-9.602l-1.537-7.562c-1.311-6.47-5.442-10.928-10.14-10.928h-4.372c-5.377 0-9.959 5.617-10.797 13.252l-.728 6.928c-.474 4.153 1.755 7.912 4.677 7.912Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M51.576 26.116q.006 1.22-.167 2.426c-.962 6.965-6.003 12.269-12.08 12.269-6.76 0-12.246-6.557-12.246-14.695v-.138c.058-6.66 3.796-12.262 8.895-13.988 1.074-.37 2.201-.56 3.337-.561C46.098 11.42 51.576 18 51.576 26.116Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M51.577 26.117q.006 1.218-.168 2.426c-.651.117-1.312.175-1.974.175-7.424 0-13.449-7.22-13.449-16.138v-.597c1.074-.37 2.201-.56 3.337-.561 6.775 0 12.254 6.579 12.254 14.695ZM35.986 12.476c0 6.878-3.869 12.568-8.903 13.5.058-6.659 3.796-12.261 8.895-13.988.008.16.008.32.008.488Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#04121D",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M59.679 76c7.364 0 13.333-5.97 13.333-13.333s-5.97-13.334-13.333-13.334-13.333 5.97-13.333 13.334S52.316 76 59.679 76Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#21A56E",
    d: "M51.957 68.904h1.66c.457 0 .831-.374.831-.83V60.6a.833.833 0 0 0-.83-.83h-1.661zm16.465-5.912q.14-.314.141-.664v-.897c0-.914-.747-1.66-1.66-1.66h-4.567l.764-3.862a.83.83 0 0 0-.067-.548 4 4 0 0 0-.73-1.013l-.382-.39-5.322 5.322c-.316.316-.49.74-.49 1.18v6.509c0 1.063.871 1.935 1.943 1.935h6.733c.582 0 1.13-.308 1.429-.806z"
  })));
};
export default SvgSmarter;